module.exports = __webpack_public_path__ + "static/media/question-dogs.f458aa3d.png";